import "./manageHero.scss";
import { useNavigate, useParams } from "react-router-dom";
import sidebarActivePage from "../../../stores/sidebarActivePage";
import snackbarStore from "../../../stores/snackbarStore";
import { useState } from "react";
import { useEffect } from "react";
import SnackbarAlert from "../../../components/snackbarAlert/snackbarAlert";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import TwoBreadcrumb from "../../../components/breadcrumbs/TwoBreadcrumb";
import heroStore from "../../../stores/heroStore";
import IOSSwitch from "../../../components/iosSwitch/IOSSwitch";
import UploadLogoImage from "../../../assets/upload-icon.png";
import DeleteIcon from "@mui/icons-material/Delete";

const ManageHero = () => {
  const HeroStore = heroStore();
  const SnackbarStore = snackbarStore();
  const SidebarActivePage = sidebarActivePage();
  const navigate = useNavigate();
  const [fileName, setFileName] = useState({
    laptopImage: "",
    tabletImage: "",
    mobileImage: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [preview, setPreview] = useState({
    laptopImage: "",
    tabletImage: "",
    mobileImage: "",
  });
  const [validateForm, setValidateForm] = useState({
    laptopImage: false,
    tabletImage: false,
    mobileImage: false,
    title: false,
    desc: false,
  });

  const params = useParams();

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Hero Section" });
    HeroStore.clearHeroForm();
    if (params.heroID !== undefined) {
      setUpdateData();
    } else {
      setIsLoading(false);
    }
  }, []);

  const setUpdateData = async () => {
    // await HeroStore.fillCategoryId({ value: params.heroID });
    // await HeroStore.fetchOneCategory();
    setIsLoading(false);
  };

  const setImage = async (files, name) => {
    const res = await HeroStore.fillHeroImage({ files, name });
    if (res === false) {
      SnackbarStore.setMassage({
        value: "File is to large. Max file size is 1.5 MB",
      });
      SnackbarStore.setIsOpen({ value: true });
    } else {
      setFileName({ ...fileName, [name]: files[0].name });
      setPreview({ ...preview, [name]: URL.createObjectURL(files[0]) });
    }
  };

  const removeImage = async (name) => {
    setFileName({ ...fileName, [name]: "" });
    setPreview({
      ...preview,
      [name]: "",
    });
    HeroStore.clearImage({ name });
  };

  const resetValidation = () => {
    setValidateForm({
      title: false,
      desc: false,
      laptopImage: false,
      tabletImage: false,
      mobileImage: false,
    });
  };

  const validate = async () => {
    await resetValidation();
    let validate = true;
    if (HeroStore.heroForm.title == "") {
      setValidateForm({
        ...validateForm,
        title: true,
      });
      validate = false;
    }
    if (HeroStore.heroForm.desc == "") {
      setValidateForm({
        ...validateForm,
        desc: true,
      });
      validate = false;
    }
    if (HeroStore.heroForm.laptopImage == "") {
      setValidateForm({
        ...validateForm,
        laptopImage: true,
      });
      validate = false;
    }
    if (HeroStore.heroForm.tabletImage == "") {
      setValidateForm({
        ...validateForm,
        tabletImage: true,
      });
      validate = false;
    }
    if (HeroStore.heroForm.mobileImage == "") {
      setValidateForm({
        ...validateForm,
        mobileImage: true,
      });
      validate = false;
    }

    if (!validate) {
      SnackbarStore.setMassage({ value: "Fill all required field" });
      SnackbarStore.setIsOpen({ value: true });
    }
    return validate;
  };

  const handleClick = async () => {
    const isValidate = await validate();
    if (!isValidate) {
      return;
    }
    setIsLoading(true);
    var res = false;
    if (params.categoryID !== undefined) {
      // res = await HeroStore.updateCategory();
      SnackbarStore.setMassage({ value: "Update Successfully" });
    } else {
      res = await HeroStore.createHero();
      SnackbarStore.setMassage({ value: "The Create Successfully" });
    }
    setIsLoading(false);
    if (res) return navigate("/hero-management");
  };

  return (
    <div className="manageHero w-100">
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        alertVariant="filled"
        alertSeverity="error"
        alertColor="error"
        massage={SnackbarStore.massage}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container>
        <Grid item xs={12}>
          <div className="heading">
            {params.heroID !== undefined ? "Edit" : "Create a new category"}
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <TwoBreadcrumb
            mainName="Hero"
            mainLink="hero-management"
            activeName={
              params.heroID !== undefined
                ? HeroStore.heroForm.categoryName
                : "New Category"
            }
          />
        </Grid>
      </Grid>
      <Grid container className="gridContainer">
        <Grid
          container
          item
          xs={1}
          md={5}
          lg={5}
          display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
          className="gridTitles"
        >
          <Grid item xs={12}>
            <h2>Details</h2>
            <p>Title, Description, Image</p>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={7}
          sm={12}
          lg={7}
          spacing={3}
          className="gridContent"
          component="form"
        >
          <Grid item xs={12} className="gridContentTitle">
            <h2>Details</h2>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              error={validateForm.title}
              helperText={validateForm.title && "Name is required"}
              label="Title"
              variant="outlined"
              className="w-100"
              name="title"
              value={HeroStore.heroForm.title}
              onChange={HeroStore.fillHeroDataWithName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Description"
              multiline
              rows={4}
              className="w-100"
              name="desc"
              value={HeroStore.heroForm.desc}
              onChange={HeroStore.fillHeroDataWithName}
            />
          </Grid>
          <Grid item xs={12}>
            <Box component="p" className="imageText">
              Hero Laptop Image *
            </Box>

            <Box
              className="fileUpload w-100"
              component="div"
              onClick={() =>
                document.querySelector(".laptop-input-flied").click()
              }
            >
              <Box
                component="img"
                sx={{
                  objectFit: "contain",
                  width: "100px",
                  height: "100px",
                }}
                className="upImage"
                src={UploadLogoImage}
              />
              <h2>Select file</h2> {/* Drop or */}
              <p>Click browse thorough your machine</p>
            </Box>
            {/* Drop file here or */}
            <input
              name="laptopImage"
              type="file"
              accept="image/*,video/*"
              className="laptop-input-flied"
              hidden
              onChange={async (e) => {
                const { files, name } = e.target;
                try {
                  if (files) {
                    await setImage(files, name);
                  }
                } catch (error) {}
              }}
            />
          </Grid>
          {preview.laptopImage && (
            <Grid item xs={12}>
              <Box className="selectedImageContainer">
                <Tooltip title="Delete">
                  <IconButton
                    className="icon"
                    onClick={() => removeImage("laptopImage")}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <Grid container spacing={2}>
                  <Grid item xs={8} sm={4} md={4} lg={3}>
                    <Box
                      component="img"
                      alt={fileName}
                      src={preview.laptopImage && preview.laptopImage}
                      className="selectedImage"
                      ml="1rem"
                      mb=".5rem"
                      sx={{
                        objectFit: "contain",
                        height: "140px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    mt="1rem"
                    ml="1.5rem"
                    display={{
                      xs: "none",
                      lg: "block",
                      sm: "block",
                      md: "block",
                    }}
                  >
                    {HeroStore.heroForm.laptopImage &&
                    HeroStore.heroForm.laptopImage.name
                      ? HeroStore.heroForm.laptopImage.name
                      : HeroStore.heroForm.laptopImage}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <Box component="p" className="imageText">
              Hero Tablet Image *
            </Box>

            <Box
              className="fileUpload w-100"
              component="div"
              onClick={() =>
                document.querySelector(".tablet-input-flied").click()
              }
            >
              <Box
                component="img"
                sx={{
                  objectFit: "contain",
                  width: "100px",
                  height: "100px",
                }}
                className="upImage"
                src={UploadLogoImage}
              />
              <h2>Select file</h2> {/* Drop or */}
              <p>Click browse thorough your machine</p>
            </Box>
            {/* Drop file here or */}
            <input
              name="tabletImage"
              type="file"
              accept="image/*,video/*"
              className="tablet-input-flied"
              hidden
              onChange={async (e) => {
                const { files, name } = e.target;
                try {
                  if (files) {
                    await setImage(files, name);
                  }
                } catch (error) {}
              }}
            />
          </Grid>
          {preview.tabletImage && (
            <Grid item xs={12}>
              <Box className="selectedImageContainer">
                <Tooltip title="Delete">
                  <IconButton
                    className="icon"
                    onClick={() => removeImage("tabletImage")}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <Grid container spacing={2}>
                  <Grid item xs={8} sm={4} md={4} lg={3}>
                    <Box
                      component="img"
                      alt={fileName}
                      src={preview.tabletImage && preview.tabletImage}
                      className="selectedImage"
                      ml="1rem"
                      mb=".5rem"
                      sx={{
                        objectFit: "contain",
                        height: "140px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    mt="1rem"
                    ml="1.5rem"
                    display={{
                      xs: "none",
                      lg: "block",
                      sm: "block",
                      md: "block",
                    }}
                  >
                    {HeroStore.heroForm.tabletImage &&
                    HeroStore.heroForm.tabletImage.name
                      ? HeroStore.heroForm.tabletImage.name
                      : HeroStore.heroForm.tabletImage}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <Box component="p" className="imageText">
              Hero Mobile Image *
            </Box>

            <Box
              className="fileUpload w-100"
              component="div"
              onClick={() =>
                document.querySelector(".mobile-input-flied").click()
              }
            >
              <Box
                component="img"
                sx={{
                  objectFit: "contain",
                  width: "100px",
                  height: "100px",
                }}
                className="upImage"
                src={UploadLogoImage}
              />
              <h2>Select file</h2> {/* Drop or */}
              <p>Click browse thorough your machine</p>
            </Box>
            {/* Drop file here or */}
            <input
              name="mobileImage"
              type="file"
              accept="image/*,video/*"
              className="mobile-input-flied"
              hidden
              onChange={async (e) => {
                const { files, name } = e.target;
                try {
                  if (files) {
                    await setImage(files, name);
                  }
                } catch (error) {}
              }}
            />
          </Grid>
          {preview.mobileImage && (
            <Grid item xs={12}>
              <Box className="selectedImageContainer">
                <Tooltip title="Delete">
                  <IconButton
                    className="icon"
                    onClick={() => removeImage("mobileImage")}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <Grid container spacing={2}>
                  <Grid item xs={8} sm={4} md={4} lg={3}>
                    <Box
                      component="img"
                      alt={fileName}
                      src={preview.mobileImage && preview.mobileImage}
                      className="selectedImage"
                      ml="1rem"
                      mb=".5rem"
                      sx={{
                        objectFit: "contain",
                        height: "140px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    mt="1rem"
                    ml="1.5rem"
                    display={{
                      xs: "none",
                      lg: "block",
                      sm: "block",
                      md: "block",
                    }}
                  >
                    {HeroStore.heroForm.mobileImage &&
                    HeroStore.heroForm.mobileImage.name
                      ? HeroStore.heroForm.mobileImage.name
                      : HeroStore.heroForm.mobileImage}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          )}
        </Grid>
        <Grid
          container
          item
          xs={12}
          mt="20px"
          sx={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
          }}
          className="btnContainer"
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "700",
            }}
          >
            <FormControlLabel
              name="active"
              checked={HeroStore.heroForm.active}
              control={<IOSSwitch sx={{ m: 1 }} />}
              onChange={(e) =>
                HeroStore.setActiveOnOrOff(!HeroStore.heroForm.active)
              }
            />
            Active
          </Box>
          <Button variant="contained" className="btn" onClick={handleClick}>
            {params.productID !== undefined ? "Save Changes" : "Create Product"}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default ManageHero;
